/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

const API_ROOT = `${process.env.API}/pass`;

// Reservations
export const reservationsEndpoint = () => `${API_ROOT}/reservations`;
export const reservationsV2Endpoint = () => `${API_ROOT}/v2/reservations`;
export const reservationEndpoint = (resId) => `${API_ROOT}/reservations/${resId}`;

// Pass Types
export const passTypesEndpoint = () => `${API_ROOT}/types`;
export const passTypeEndpoint = (passId) => `${API_ROOT}/types/${passId}`;

// Pass Series
export const seriesEndpoint = (id) => `${API_ROOT}/series/${id}`;

// Address
export const verifyAddressEndpoint = () => `${process.env.API}/accounts/address/verify`;
